import { BuildingOfficeIcon, EnvelopeIcon } from "@heroicons/react/24/solid";
import * as React from "react";
import { Avatar, Button, Spinner } from "components/elements";
import { useFollow } from "hooks/useFollow";
import { usePublicUser } from "hooks/usePublicUser";

export const ProfileTooltip = ({ authorId }: { authorId: string }) => {
    const id = Number(authorId);
    const { isInitialLoading, error, user } = usePublicUser(id);
    const { handleFollow, followLoading, showFollowButton, isFollowed } = useFollow(id);

    if (isInitialLoading) {
        return (
            <div>
                <Spinner className="h-4 w-4" />
            </div>
        );
    }

    if (error) {
        return <div>{error.message}</div>;
    }

    if (!user) {
        return <div>User not found</div>;
    }

    return (
        <div>
            <div className="flex flex-nowrap gap-3">
                <Avatar
                    className="h-[5rem] w-[5rem] shrink-0 border-2 border-slate-300 bg-slate-200 text-xl text-slate-400 shadow-inner"
                    photoUrl={user?.avatarUrl}
                    name={user.name}
                />
                <div className="flex flex-col items-start justify-between gap-2 text-xs text-slate-700">
                    <div className="text-sm text-slate-900">{user.name}</div>
                    {!user.deletedAt && (
                        <div className="flex items-center gap-1">
                            <EnvelopeIcon className="h-4 w-4 text-slate-500" />
                            {user.email || "-"}
                        </div>
                    )}
                    <div className="flex hidden items-center gap-1">
                        <BuildingOfficeIcon className="h-4 w-4 text-slate-500" />
                        {user?.meta.organization}
                    </div>
                </div>
            </div>

            {showFollowButton && (
                <Button
                    isLoading={followLoading}
                    size="smallest"
                    className="w-auto"
                    onClick={(event) => handleFollow(event)}
                    variant={isFollowed ? "secondary" : "primary"}
                >
                    {isFollowed ? "Unfollow" : "Follow"}
                </Button>
            )}
        </div>
    );
};
